import {gql} from '@apollo/client'

export const GET_DRAFT_ORDERS = gql`
  query GetDraftOrders(
    $offset: Int!
    $pageSize: Int!
    $orderBy: [DraftOrdersOrderBy!]
    $filter: DraftOrderFilter!
  ) {
    draftOrders(first: $pageSize, offset: $offset, orderBy: $orderBy, filter: $filter) {
      nodes {
        id
        name
        orderNumber
        totalPrice
        createdAt
        status
        customer {
          firstName
          lastName
        }
      }
      totalCount
    }
  }
`

export const DELETE_DRAFT_ORDER = gql`
  mutation DeleteDraftOrder($id: UUID!) {
    deleteDraftOrder(input: {id: $id}) {
      clientMutationId
    }
  }
`
export const APPLY_DISCOUNT_CODE = gql`
  mutation DraftOrderDiscountCodeApply($discount: DraftOrderDiscountInput!) {
    draftOrderDiscountCodeApply(input: $discount) {
      status
      discountAmount
      id
      discounts
      shippingRate
    }
  }
`

export const VALIDATE_DRAFT_ORDER_DISCOUNT = gql`
  mutation DraftOrderValidateDiscount($discount: DraftOrderValidateDiscountInput!) {
    draftOrderValidateDiscount(input: $discount) {
      discountAmount
      errors
      status
      discounts
      shippingRate
    }
  }
`

export const REMOVE_DRAFT_ORDER_DISCOUNTS = gql`
  mutation RemoveDraftOrderDiscounts($discount: RemoveDraftOrderDiscountsInput!) {
    removeDraftOrderDiscounts(input: $discount) {
      clientMutationId
    }
  }
`

export const APPLY_WINE_CLUB_DISCOUNT = gql`
  mutation DraftOrderWineClubDiscountApply($discount: DraftOrderWineClubDiscountInput!) {
    draftOrderWineClubDiscountApply(input: $discount) {
      status
      discountAmount
      id
      discounts
    }
  }
`

export const UPDATE_DRAFT_ORDER_PAYMENT_METHOD = gql`
  mutation updateDraftOrderPaymentBilling(
    $paymentMethodId: UUID!
    $id: UUID!
    $billingAddressId: UUID!
  ) {
    updateDraftOrderPaymentBillingAddress(
      input: {
        pBillingAddressId: $billingAddressId
        pDraftOrderId: $id
        pPaymentMethodId: $paymentMethodId
      }
    ) {
      clientMutationId
    }
  }
`

export const CREATE_SHIPPING_RATE = gql`
  mutation UpdateDraftOrder($draftOrder: UpdateDraftOrderInput!) {
    updateDraftOrder(input: $draftOrder) {
      shippingRate {
        id
      }
    }
  }
`

export const UPDATE_SHIPPING_RATE = gql`
  mutation UpdateShippingRate($shippingRate: UpdateShippingRateInput!) {
    updateShippingRate(input: $shippingRate) {
      clientMutationId
    }
  }
`

export const COMPLETE_DRAFT_ORDER = gql`
  mutation CompleteDraftOrder($draftOrder: DraftCompleteInput!) {
    draftOrderComplete(input: $draftOrder) {
      orderId
      status
      errors
    }
  }
`

export const COMPLETE_DRAFT_ORDER_WITH_CASH_AND_CHEQUE = gql`
  mutation CompleteDraftOrderWithCashAndCheque($draftOrder: DraftCompleteWithCashAndChequeInput!) {
    draftOrderCompleteWithCashAndCheque(input: $draftOrder) {
      orderId
      status
      errors
    }
  }
`
